// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__4r+4o","content":"styles_content__SIOOu","text":"styles_text__knxDC"};